import apiClient from "services/axios";

const API = {
  list: "/api/v1/widgets",
  create: "/api/v1/widgets",
  detail: "/api/v1/widgets",
  update: "/api/v1/widgets",
  delete: "/api/v1/widgets",
  position: "/api/v1/widgets/positions",
  grid: "/api/v1/widgets/grids",
};

export const list = async (filter) => {
  const response = await apiClient.get(API.list, { params: filter });
  if (response) {
    return response.data;
  }
  return false;
};

export const create = async (body) => {
  const response = await apiClient.post(API.create, body);
  if (response) {
    return response.data;
  }
  return false;
};

export const detail = async (id) => {
  const response = await apiClient.get(`${API.detail}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};

export const update = async (id, body) => {
  const response = await apiClient.patch(`${API.update}/${id}`, body);
  if (response) {
    return response.data;
  }
  return false;
};

export const remove = async (id) => {
  const response = await apiClient.delete(`${API.delete}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};

export const changeIndex = async (body) => {
  const response = await apiClient.put(API.position, body);
  if (response) {
    return response.data;
  }
  return false;
};

export const updateGridsLayout = async (body) => {
  const response = await apiClient.put(API.grid, body);
  if (response) {
    return response.data;
  }
  return false;
};
